import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import BackArrow from './BackArrow';
import { fireGTM } from '../../gtm/gtmUtil';
import { backArrow_GTM } from '../../gtm/datalayers/utilDataLayers.json';

const RouteBack = ({ history, color, route, tenant, section, text }) => {
  const { t } = useTranslation();
  const routeUser = () => {
    // Google Tag Manager
    fireGTM(backArrow_GTM, text, section);
    history.push(`/${tenant.name.toLowerCase()}${route}`);
  };

  const handleOnKeyDown = (e) => {
    if (['Enter'].includes(e.key)) {
      routeUser();
    }
  };

  return (
    <div
      onClick={routeUser}
      onKeyDown={handleOnKeyDown}
      role="button"
      tabIndex={0}
      className="route-back"
    >
      <div className="back-button" data-cy="back-button">
        <BackArrow color={color} title="Back Arrow" />
      </div>
      <p className="back-text" style={{ color }}>
        {t('Back', { context: 'Direction' })}
      </p>
    </div>
  );
};

export default withRouter(RouteBack);

RouteBack.propTypes = {
  color: PropTypes.string.isRequired,
  route: PropTypes.string.isRequired,
};
